import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Modal,
} from "reactstrap";
import base64 from "base-64";
import LoginError from "../../components/LoginError/LoginError";

import config from "../../config";
import { GraphQLClient } from "graphql-request";
import queries from "../../singletons/RequestManager/queries";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
class StoreUserRegistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      otpText: "",
      loginModalVisible: false,
      loginErrorMessage: "",
      showOTP: false,
      authTokenTemp: "",
      show_create_OTP:true,
      password: "",
      confirmPassword: "",
      showresetpwd:false
    };
  }

  componentDidMount() {
    let reloadActive = localStorage.getItem("reloadActive");
    if (reloadActive === null) {
      localStorage.setItem("reloadActive", "Y");

      window.location.reload();
      if (this.state.otpVerified== false) {
        localStorage.setItem("phone_verified", false);
      }
    }
  }

  render() {
    return this.renderLoginForm();
  }
  toggleErrorLoginModal = (text) => {
    this.setState({
      loginModalVisible: !this.state.loginModalVisible,
      loginErrorMessage: text,
    });
  };
  renderLoginForm = () => {
    return (
      <div style={{ marginTop: 10 }}>
        
        <Container>
          <Modal
            size="lg"
            isOpen={this.state.loginModalVisible}
            toggle={this.toggleErrorLoginModal}
          >
            <LoginError
              editable={true}
              loginErrorMessage={this.state.loginErrorMessage}
              goBack={this.toggleErrorLoginModal}
            />
          </Modal>
          <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
            <Col>
              <div style={{fontSize:20}}>
                RESET PASSWORD
              </div>
            </Col>   
          </Row>
          <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
            <Col>
               <div>
                   Enter you registerd phone number
               </div> 
              <Input type="number" style={{height: 40,width: "95%",fontSize: 16,color: "black",}} placeholder="phone number"onChange={(event) => {this.setState({ phone: event.target.value });}}/>
                {this.state.showOTP === false ? (
                  <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                    <Col >
                      {(this.state.show_create_OTP === true) && (
                          <Button color="primary" className="px-4" onClick={() => {this.generateOTP();}}>Next</Button>
                        )}
                        </Col>
                      </Row>
                    ) : (
                      <div>
                        {(this.state.show_create_OTP === false) && (
                          <Input type="number" style={{height: 40,width: "95%",fontSize: 16,color: "black",}} placeholder="Enter otp" onChange={(event) => {this.setState({ otpText: event.target.value }); }} />
                        )}
                        <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                          <Col>
                            {(this.state.show_create_OTP === false) && (
                            <Button color="primary" className="px-2" onClick={() => {this.verifyOTP();}}>Verify</Button>
                              
                            )}
                            </Col>
                            <Col>
                            {(this.state.show_create_OTP === false) && (
                              <Button color="primary" className="px-2" onClick={() => {this.generateOTP();}}>ReSend-OTP</Button>
                            )}
                          </Col>
                        </Row>
                        {(this.state.show_create_OTP === true) && ( 
                            <div>
                     <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                     <p style={{fontSize:20}}>{"Enter New Password"}</p>
                    </Row>       
                     <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                            <p style={{fontSize:20}}>{"Store Password"}</p>
                            <Input type="password" style={{height: 40,width: "95%",fontSize: 16,color: "black",}}
                            placeholder="Enter password"
                            value={this.state.password}
                            onChange={(event) => {
                                this.setState({ password: event.target.value });
                            }}
                            />
                        </Row>

                        <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                            <p style={{fontSize:20}}>{"Store Confirm Password"}</p>
                            <Input type="password" style={{height: 40, width: "95%",fontSize: 16,color: "black",}}
                            autoComplete="nope" onFocus={this.onFocus}
                            placeholder="Enter confirm password"
                            value={this.state.confirmPassword}
                            onChange={(event) => {
                                this.setState({ confirmPassword: event.target.value });
                            }}
                            />
                        </Row>
                        <Row xs="12" sm="12" md="4" lg="4" style={{ display: "flex", alignItems: "center", margin: 10 }}>
                        <Col>
                            <Button color="primary" className="px-2" onClick={this.ResetPassword}>Set Password</Button>
                            
                          </Col>
                        </Row>
                        </div>
                        )}
                            </div>
                    )}
                    
                    
            </Col>
          </Row>
        </Container>
      </div>
    );
  };

  generateOTP = async () => {
    try {
      this.setState({ phoneNumberConfirmed: true });
      let response = await fetch(
        config.getHost() + "/api/account/otp-generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone: "+91" + this.state.phone,
          }),
        }
      );
      let responseJSON = await response.json();

      if (responseJSON.success === true) {
        this.setState({ showOTP: true });
        this.setState({show_create_OTP:false});
      } else {
        this.setState({ showOTP: false });
        alert("Please ensure you've entered a valid phone number");
      }
    } catch (error) {
      alert("Something went wrong, try again");
      console.log("OTP error", error);
      this.setState({
        showOTP: false,
      });
    }
  };

  verifyOTP = async () => {
    try {
      this.setState({ otpConfirmed: true });
      let response = await fetch(config.getHost() + "/api/account/otp-verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone: "+91" + this.state.phone,
          otp: this.state.otpText,
        }),
      });
      let responseJSON = await response.json();
      console.log("responseJSON", JSON.stringify(response));
      if (responseJSON.success === true) {
        console.log("responseJSON.success", responseJSON.success , this.state.otpText);
        localStorage.setItem("authTokenTemp", responseJSON.token);
      // Peri VAPT comment
        // console.log("Auth token", responseJSON.token);
        this.setState({
          otpVerified: true,
          authTokenTemp: responseJSON.token,
          show_create_OTP:true
        });
        
        localStorage.setItem("phone_verified", true);
        this.getUserProfile(responseJSON);
        alert("phone number verified sucessfully");

      } else {
        this.setState({ otpVerified: false, otpConfirmed: false });
        alert("Incorrect OTP", "Please check the OTP recieved or try again.");
        localStorage.setItem("phone_verified", false);
      }

      //alert("Please enter a valid 6 digit OTP.");
    } catch (error) {
      alert(error.message);
      this.setState({
        phoneNumberConfirmed: false,
        OTPReceived: false,
        otpVerified: false,
        otpConfirmed: false,
      });
    }
  };

  getUserProfile = async (data) => {
    try {
      var vtimestamp = generateEpochTimestamp();    
      let url = config.getHost() + "/graph";
      let tempClient = new GraphQLClient(url, {
        headers: {
          Authorization: `Token ${data.token}`,
          Timestamp: vtimestamp,
          Signature: generateSignature(vtimestamp, data.token)              
        },
      });
      let resp = await tempClient.request(queries["getUserProfile"], {});

      // if (resp.status === 200) {
      // let json = await resp.json();
      console.log("getUserProfile resp", JSON.stringify(resp));
      localStorage.setItem("storeUserTemp", JSON.stringify(resp));
      localStorage.setItem("phone_verified", true);
      this.state.showresetpwd = true;
      console.log("getUserProfile resp", this.state.showresetpwd);

    } catch (error) {
      alert(
        "Some thing went wrong, with this device already used,please use same user phone"
      );
      console.log("err", JSON.stringify(error));
      localStorage.setItem("phone_verified", false);
    }
  };

  ResetPassword = async (data) => {
    try {
      if (this.state.password.length < 8){
        alert("Please enter password more than 8 characters");
        return;
      }
      if (this.state.password !== this.state.confirmPassword){
        alert("Password and confirm password does not match");
        return;
      }

      let storeUserTemp = JSON.parse(localStorage.getItem("storeUserTemp"));
      console.log(
        "storeUserTemp",
        JSON.stringify(storeUserTemp.userProfile.user.id)
      );
      let params = {
        input: {
          password: this.state.password,
          userId: storeUserTemp.userProfile.user.id,
          
        },
      };
      var vtimestamp = generateEpochTimestamp();  
      let url = config.getHost() + "/graph";
      let tempClient = new GraphQLClient(url, {
        headers: {
          Authorization: `Token ${this.state.authTokenTemp}`,
          Timestamp: vtimestamp,
          Signature: generateSignature(vtimestamp, data.token)             
        },
      });
      let resp = await tempClient.request(queries["createStorePerson"], params);

      // if (resp.status === 200) {
      // let json = await resp.json();
      console.log("resp", JSON.stringify(resp));
      this.setState({ spinnerLoading: false });
      this.toggleErrorLoginModal("Password Reset Successfully.");
      return <Redirect to="/login" />;
    } catch (error) {
      this.setState({ spinnerLoading: false });
      alert(
        "Some thing went wrong, with this device already used,please use same user phone"
      );
      console.log("err", JSON.stringify(error));
    }
  };

  submitCredentials = async () => {
    var vtimestamp = generateEpochTimestamp();  
    let headers = new Headers({
      Authorization: `Basic ` + base64.encode(this.email + ":" + this.password),
      Timestamp: vtimestamp,
      Signature: generateSignature(vtimestamp, base64.encode(this.email + ":" + this.password))          
    });

    try {
      let response = await fetch(
        config.getHost() + "/api/account/store/login/",
        {
          method: "POST",
          headers: headers,
        }
      );

      console.log("isBrowserresponse1", response);
      if (response.status === 200) {
        let json = await response.json();
        // Peri VAPT comment
        // console.log("storeInformation-login", json);
      } else {
        this.toggleErrorLoginModal("Please check the username and password.");
        // throw "Incorrect username password";
      }
    } catch (error) {
      this.toggleErrorLoginModal(JSON.stringify(error));
    }
    // } else if (window.GNGFcmtoken && window.GNGFcmtoken != null) {
  };
}

export default StoreUserRegistration;



// WEBPACK FOOTER //
// ./src/pages/StoreUserRegistration/StoreUserRegistration.js